jQuery(function($) {
	if (!$('footer div.instagram').length)
		return;

	$('footer div.instagram_wrapper').on('init', function() {
		$('div.instagram .slick-slide:not(.slick-active)').find('.content_wrapper *').attr('tabindex', -1);

		$('.instagram .slider_arrow').on('click', function() {
			setTimeout(function(){
				var currentSlideEl = $('.instagram .instagram_wrapper .slick-active');
				currentSlideEl.find('.content_wrapper *:first-child').focus();
			}, 100);
		});
	});

	initializeSlick('footer div.instagram_wrapper', {
		accessibility: true,
		dots: false,
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 5,
		variableWidth: false,
		arrows: true,
		nextArrow: 'div.instagram .next_arrow',
		prevArrow: 'div.instagram .prev_arrow',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 641,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('footer div.instagram_wrapper').on('mouseleave', '.slick-slide', function() {
		//reset widths of current slick slide and siblings
		$(this).css('width', '').removeClass('hovered');
		$(this).siblings('.slick-active').removeClass('collapsed').css('width', '');
	});

	$('footer div.instagram_wrapper').on('mouseenter', '.slick-slide', function() {
		var siblings = $(this).siblings('.slick-active');
		var siblingsCount = siblings.length;

		//calculate slide width and add 200
		var wrapperWidth = $('.instagram_wrapper').width();
		var slideWidthWithPadding = (wrapperWidth / (siblingsCount + 1)) + 192;
		$(this).css('width', slideWidthWithPadding).addClass('hovered');
		
		siblings.each(function() {
			//calculate slide width based on .instagram_wrapper width divided by number of siblings with active class
			var wrapperWidth = $('.instagram_wrapper').width();
			var siblingWidth = (wrapperWidth / (siblingsCount + 1)) - (192 / siblingsCount);
			$(this).addClass('collapsed');
			$(this).css('width', siblingWidth);
		});

	});


	$('footer div.instagram_wrapper').on('afterChange', function() {
		setTimeout(function(){
			currentSlideEl = $('.instagram .instagram_wrapper .slick-active');
			$('div.instagram .slick-slide').find('.content_wrapper *').attr('tabindex', -1);
			currentSlideEl.find('.content_wrapper *').attr('tabindex', 0);
		}, 100);
	});

	// $(window).on('resize orientationchange', function() {
	// 	$('footer div.instagram_wrapper')[0].slick.refresh();
	// });

});